module.exports = __webpack_public_path__ + "static/media/fold-select.a1546765.png";